import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type CreateApiKeyResponse = {
  id: string;
  name: string;
  rawKey: string;
  createdAt: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
};

export const useCreateTenantApiKey = (companyId: string) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<{ data: CreateApiKeyResponse }, Error, { name: string }>({
    mutationFn: ({ name }) =>
      api.post<CreateApiKeyResponse>(`admin/companies/${companyId}/api-keys`, { name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies', companyId, 'api-keys'] });
    },
  });

  return { createKey: mutateAsync, isLoading, error, reset };
};
